import React from 'react';

const SortingArrow = ({ width = '16', height = '16', className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      role="img"
      aria-hidden="true"
      {...rest}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1553 7.84467C13.4482 8.13756 13.4482 8.61244 13.1553 8.90533L8.90533 13.1553C8.61244 13.4482 8.13756 13.4482 7.84467 13.1553L3.5947 8.90533C3.3018 8.61244 3.3018 8.13756 3.5947 7.84467C3.8876 7.55178 4.3624 7.55178 4.6553 7.84467L7.625 10.8143L7.625 3.375C7.625 2.96079 7.96079 2.625 8.375 2.625C8.78921 2.625 9.125 2.96079 9.125 3.375V10.8143L12.0947 7.84467C12.3876 7.55178 12.8624 7.55178 13.1553 7.84467Z"
        fill="#666666"
      />
    </svg>
  );
};

export default SortingArrow;
